// Handles sharing content to social media through share buttons.

Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {
    var SOCIAL_SHARE_PARAM = Routes.social_share_param();
    Concerns.socialShareHelpers = {
        onShow: function() {
            var receiveMessage = function(event) {
                var eventData;
                if (event.data) {
                    try {
                        eventData = JSON.parse(event.data);
                    } catch (error) {
                        // Some other way of sending data, ignore
                        return;
                    }
                } else {
                    return;
                }
                // listen for the share event being trigged from the parent (which sends down the full URL of the page of the embedded widget)
                if (eventData.name && eventData.name === 'pixlee:trigger:share:to:social') {
                    var photoModel = App.request('get:new:photo', eventData.data.photoJson);
                    switch (eventData.data.source) {
                        case 'facebook':
                            this.handleFacebookShare(photoModel, eventData.data.url);
                            break;
                        case 'twitter':
                            this.handleTwitterShare(photoModel, eventData.data.url);
                            break;
                        case 'pinterest':
                            this.handlePinterestShare(photoModel, eventData.data.url);
                            break;
                        case 'tumblr':
                            this.handleTumblrShare(photoModel, eventData.data.url);
                            break;
                        default:
                            break;
                    }
                }
            }.bind(this);
            window.addEventListener('message', receiveMessage, false);
        },
        insertParam: function(url, paramName, paramValue) {
            if (url.indexOf(paramName + '=') >= 0) {
                var prefix = url.substring(0, url.indexOf(paramName));
                var suffix = url.substring(url.indexOf(paramName)).substring(url.indexOf('=') + 1);
                suffix = (suffix.indexOf('&') >= 0) ? suffix.substring(suffix.indexOf('&')) : '';
                url = prefix + paramName + '=' + paramValue + suffix;
            } else {
                if (url.indexOf('?') < 0) {
                    url += '?' + paramName + '=' + paramValue;
                } else {
                    url += '&' + paramName + '=' + paramValue;
                }
            }
            return url;
        },
        generateUtmTags: function(content, utmObj, source) {
            if (!_.isEmpty(utmObj)) {
                content = _.isTruthy(source) ? this.insertParam(content, 'utm_source', App.request('encode:utf8', source)) : content;
                content = _.isTruthy(utmObj.medium) ? this.insertParam(content, 'utm_medium', App.request('encode:utf8', utmObj.medium)) : content;
                content = _.isTruthy(utmObj.campaign) ? this.insertParam(content, 'utm_campaign', App.request('encode:utf8', utmObj.campaign)) : content;
                content = _.isTruthy(utmObj.term) ? this.insertParam(content, 'utm_term', App.request('encode:utf8', utmObj.term)) : content;
                content = _.isTruthy(utmObj.content) ? this.insertParam(content, 'utm_content', App.request('encode:utf8', utmObj.content)) : content;
            }
            return content;
        },
        handlePinterestShare: function(model, url) {
            var utmObj = gon.display_options && gon.display_options.utm ? gon.display_options.utm : {};
            var title = this.getTitle(model);
            var shareLink = this.insertParam(url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            shareLink = this.generateUtmTags(shareLink, utmObj, 'pinterest');
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
            } else {
                title = App.request('decode:utf8', title);
            }
            var popupUrl = 'https://pinterest.com/pin/create/button/?url=' + App.request('encode:utf8', shareLink) + '&media=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&description=' + App.request('encode:utf8', title);
            popupUrl = this.generateUtmTags(popupUrl, utmObj, 'pinterest');
            window.open(popupUrl, '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            this.trackShare(model.get('album_photo_id'), shareLink, 'pinterest', undefined, shareLink, utmObj);
        },
        handleTumblrShare: function(model, url) {
            var utmObj = gon.display_options && gon.display_options.utm ? gon.display_options.utm : {};
            var title = this.getTitle(model);
            var shareLink = this.insertParam(url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            var shortUrl = model.get('short_share_url') || shareLink;
            shortUrl = this.generateUtmTags(shortUrl, utmObj, 'tumblr');
            shareLink = this.generateUtmTags(shareLink, utmObj, 'tumblr');
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
            } else {
                title = App.request('decode:utf8', title);
            }
            var popupUrl = 'https://www.tumblr.com/share/photo?clickthru=' + App.request('encode:utf8', shortUrl) + '&source=' + App.request('encode:utf8', App.request('get:photo:tumbnail', model)) + '&caption=' + App.request('encode:utf8', title);
            popupUrl = this.generateUtmTags(popupUrl, utmObj, 'tumblr');
            window.open(popupUrl, '_blank', 'height=450,width=600,toolbar=0,resizable=0');
            this.trackShare(model.get('album_photo_id'), shareLink, 'tumblr', undefined, shortUrl, utmObj);

        },
        handleFacebookShare: function(model, url) {
            var utmObj = gon.display_options && gon.display_options.utm ? gon.display_options.utm : {};
            var title = this.getTitle(model);
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
            }
            var shareLink = this.insertParam(url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            var album_photo_id = model.attributes.album_photo_id;

            var fingerprint = gon.distinct_user_hash;

            var post_id = null;
            var host = window.location.protocol + '//' + window.location.host;
            var content = SOCIAL_SHARE_PARAM;
            var albumTitle = gon.current_album ? gon.current_album.title : '';
            content = this.insertParam(content, 'descr', App.request('encode:utf8', App.request('encode:utf8', title)));
            content = this.insertParam(content, 'title', App.request('encode:utf8', App.request('decode:utf8', albumTitle)));
            content = this.insertParam(content, 'img', App.request('encode:utf8', App.request('get:photo:tumbnail', model)));
            content = this.insertParam(content, 'shareLink', App.request('encode:utf8', shareLink));
            content = this.insertParam(content, 'album_photo_id', App.request('encode:utf8', album_photo_id));
            content = this.insertParam(content, 'fingerprint', App.request('encode:utf8', fingerprint));
            content = this.insertParam(content, 'post_id', App.request('encode:utf8', post_id));
            content = this.insertParam(content, 'type', 'image');
            content = this.insertParam(content, 'source', 'facebook');
            content = this.generateUtmTags(content, utmObj, 'facebook');
            var fbShareUrlParams = host + content;
            window.open(fbShareUrlParams, '_blank', 'height=450,width=600,toolbar=0,resizable=0');
        },
        handleTwitterShare: function(model, url) {
            var utmObj = gon.display_options && gon.display_options.utm ? gon.display_options.utm : {};
            var author = model.get('user_name');
            var title = this.getTitle(model);
            if (_.isFalsy(title)) {
                if (gon.current_album.campaign) {
                    title = 'I just voted for my favorite photo!';
                } else {
                    title = 'Check this photo out!';
                }
            }
            var shareLink = this.insertParam(url, 'pixlee_album_photo_id', model.get('album_photo_id'));
            var album_photo_id = model.attributes.album_photo_id;

            var fingerprint = gon.distinct_user_hash;

            var post_id = null;
            var host = window.location.protocol + '//' + window.location.host;
            var content = SOCIAL_SHARE_PARAM;
            var albumTitle = gon.current_album ? gon.current_album.title : '';
            content = this.insertParam(content, 'descr', App.request('encode:utf8', App.request('encode:utf8', title)));
            content = this.insertParam(content, 'title', App.request('encode:utf8', App.request('decode:utf8', albumTitle)));
            content = this.insertParam(content, 'img', App.request('encode:utf8', App.request('get:photo:tumbnail', model)));
            content = this.insertParam(content, 'shareLink', App.request('encode:utf8', shareLink));
            content = this.insertParam(content, 'album_photo_id', App.request('encode:utf8', album_photo_id));
            content = this.insertParam(content, 'fingerprint', App.request('encode:utf8', fingerprint));
            content = this.insertParam(content, 'post_id', App.request('encode:utf8', post_id));
            content = this.insertParam(content, 'type', 'image');
            content = this.insertParam(content, 'author', author);
            content = this.insertParam(content, 'source', 'twitter');
            content = this.generateUtmTags(content, utmObj, 'twitter');
            var twitterShareUrlParams = host + content;
            window.open(twitterShareUrlParams, '_blank', 'height=450,width=600,toolbar=0,resizable=0');
        },
        trackShare: function(photoId, link, service, post_id, shortlink, utmObj) {
            clearTimeout(this.shareTimer);
            this.shareTimer = setTimeout(function() {
                var post;
                if (typeof post_id == 'undefined') {
                    post = null;
                } else {
                    post = post_id;
                }
                if (parseInt(photoId) > 0) {
                    $.ajax({
                        url: '/social/share',
                        type: 'post',
                        data: {
                            'album_photo_id': parseInt(photoId),
                            'fingerprint': gon.distinct_user_hash,
                            'link': link,
                            'shortlink': shortlink,
                            'provider': service,
                            'post_id': post,
                            'utm_medium': utmObj.medium || '',
                            'utm_campaign': utmObj.campaign || '',
                            'utm_term': utmObj.term || '',
                            'utm_content': utmObj.content || ''
                        },
                        dataType: 'json',
                        success: function(response) {
                            if (response.error_code !== 0) {
                                //console.log('Error logging like');
                            }
                        }
                    });
                }
            }, 2000);
        },
        getTitle: function(model) {
            if (gon.display_options.options && !gon.display_options.options.showCaptions) {
                return '';
            }
            if (_.isTruthy(model.attributes.title)) {
                return model.attributes.title;
            }
            if (_.isTruthy(model.attributes.album_title)) {
                return model.attributes.album_title;
            }
            if (_.isTruthy(model.attributes.photo_title)) {
                return model.attributes.photo_title;
            }
            return false;
        },
    };
});
